import { Injectable } from "@angular/core";
import { formatNumberWithDotSeparator } from "../../utils/string-utils";
import { DecimalPipe } from '@angular/common';

@Injectable({
    providedIn: 'root'
})
export default class NumberFormatService {
    constructor(private readonly decimalPipe: DecimalPipe){}

    public formatNumberWithDotSeparator(input: any): string {
        if (input === undefined || input === null) {
            return "";
        }
        let value = input.toString().replace(/\D/g, '');

        if (value){
            value = Number(value).toString();
        }

        if (value.length > 3) {
            value = formatNumberWithDotSeparator(Number(value));
        }

        return value;
    }

    public calculateCaretPositionForFormattedNumber(originalCaretPosition: number, rawValue: string, formattedValue: string): number {
        // keep the position of the cursor if there is leading zero '0'
        if (rawValue.length > 1 && rawValue[0] === '0'){
            originalCaretPosition--;
        }

        // Get the (n) number of digits stand in front of the cursor
        let numberOfDigitsBeforeCursor = rawValue.substring(0, originalCaretPosition).replace(/\D/g, '').length;
        let newCaretPosition = formattedValue.length;

        // Loop through each character of the formatted string and determine the caret position
        // The caret position is located after the (n) number of digits found
        for (let i = 0; i < formattedValue.length; i++) {
            if (formattedValue[i] !== '.'){
                numberOfDigitsBeforeCursor--;
            }
            if (numberOfDigitsBeforeCursor === 0) {
                newCaretPosition = i + 1;
                break;
            }
        }
        if(originalCaretPosition === 0) {
            newCaretPosition = 0;
        }

        return newCaretPosition;
    }

    public formatPercentage(value: number): string{
        return this.decimalPipe.transform(value, '1.1-1')?.toString()+'%' ?? value?.toString() ?? "";
    }

    public handleValueIfDeleteDotSeparator(rawValue: string, formattedValue: string, originalCaretPosition: number, inputType: string) {
        if(this.checkDotSeparatorsChanged(rawValue, formattedValue)){
            if(inputType == "deleteContentForward") {
                const newFormattedValue = formattedValue.slice(0, originalCaretPosition)
                    + formattedValue.slice(originalCaretPosition + 2, formattedValue.length);
                return this.formatNumberWithDotSeparator(newFormattedValue);
            }
            if(inputType == "deleteContentBackward") {
                const newFormattedValue = formattedValue.slice(0, originalCaretPosition - 1)
                    + formattedValue.slice(originalCaretPosition + 1, formattedValue.length);
                return this.formatNumberWithDotSeparator(newFormattedValue);
            }
        }
        return formattedValue;
    }

    public calculateCaretPositionIfDeleteDotSeparator(rawValue: string, formattedValueBeforeDotDeletion: string, formattedValueAfterDotDeletion: string, newCaretPosition: number, inputType: string) {
        if(this.checkDotSeparatorsChanged(rawValue, formattedValueBeforeDotDeletion)){
            if(inputType == "deleteContentForward") {
                newCaretPosition++;
            }
            if(inputType == "deleteContentBackward") {
                newCaretPosition--;
            }
            if(formattedValueAfterDotDeletion.replace(/\D/g, '').length % 3 == 0) {
                newCaretPosition--;
            }
        }
        if(newCaretPosition < 0) {
            newCaretPosition = 0;
        }
        return newCaretPosition;
    }

    checkDotSeparatorsChanged(rawValue: string, formattedValue: string) {
        const rawValueDots = rawValue.split(".",).length;
        const formattedValueDots = formattedValue.split(".",).length;
        return rawValueDots !== formattedValueDots && rawValue.length < formattedValue.length;
    }
}
